(() => {
  'use strict';
  const text = product => [product.handle, product.product_type, product.productType, product.type, product.title].filter(Boolean).join(' ').toLowerCase().replace(/[-_–—]+/g, ' ').replace(/\s+/g, ' ');
  const classify = product => {
    const value = text(product);
    const swim = /\b(bikini|tankini|swimsuit|swimwear|swimset|swim)\b/.test(value);
    const set = /\b(sets?|two piece|three piece|four piece|2 piece|3 piece|4 piece)\b/.test(value);
    if (swim && set && !/\bswim cover up\b/.test(value)) return 'swim_set';
    if (/\b(cover ?ups?|coverups|kimono|sarong|beach wrap|swim skirts?)\b/.test(value)) return 'swim_layer';
    if (/\bbodysuits?\b/.test(value)) return 'bodysuit';
    if (swim && /\b(tops?|bralettes?|bandeau top)\b/.test(value)) return 'swim_top';
    if (swim && /\b(bottoms?|briefs?|thongs?|shorts?|pants?|trousers?)\b/.test(value)) return 'swim_bottom';
    if (swim && /\b(one piece|onepiece|monokini|swimsuit|swim dress)\b/.test(value)) return 'one_piece';
    if (swim) return 'swim_set';
    if (set) return 'outfit_set';
    if (/\b(dress(?:es)?|rompers?|jumpsuits?)\b/.test(value)) return 'full_outfit';
    if (/\b(cardigans?|jackets?|blazers?|coats?|robes?|outerwear)\b/.test(value)) return 'layer';
    if (/\b(pants?|trousers?|shorts|skirts?|skorts?|leggings?|culottes?|joggers?|sweatpants|palazzo)\b/.test(value)) return 'bottom';
    if (/\b(tops?|shirts?|blouses?|tees?|tanks?|camis?|camisoles?|sweaters?|hoodies?|sweatshirts?|pullovers?|tunics?|bralettes?|bustiers?|corsets?|vests?)\b/.test(value)) return 'top';
    return 'unknown';
  };
  const rules = {
    swim_set: ['swim_layer'], one_piece: ['swim_layer'],
    swim_top: ['swim_bottom', 'swim_layer'], swim_bottom: ['swim_top', 'swim_layer'],
    swim_layer: ['swim_set', 'one_piece'],
    top: ['bottom', 'layer'], bodysuit: ['bottom', 'layer'],
    bottom: ['top', 'bodysuit', 'layer'],
    full_outfit: ['layer'], outfit_set: ['layer'],
    layer: ['top', 'bodysuit', 'bottom', 'full_outfit', 'outfit_set'], unknown: []
  };
  const sources = {
    swim_set: ['cover-ups', 'swim-skirts-swim-dresses'], one_piece: ['cover-ups', 'swim-skirts-swim-dresses'],
    swim_top: ['swim-bottoms', 'cover-ups'], swim_bottom: ['swim-tops', 'cover-ups'],
    swim_layer: ['bikinis', 'one-pieces'],
    top: ['everyday-essentials', 'dresses-skirts'], bodysuit: ['everyday-essentials', 'dresses-skirts'],
    bottom: ['tops-t-shirts', 'bodysuits', 'everyday-essentials'],
    full_outfit: ['everyday-essentials', 'tops-t-shirts'], outfit_set: ['everyday-essentials', 'tops-t-shirts'],
    layer: ['everyday-essentials', 'tops-t-shirts', 'bodysuits'], unknown: []
  };
  const available = product => product.available !== false && (!Array.isArray(product.variants) || product.variants.some(variant => variant.available === true));
  const allowed = (source, candidate) => (rules[classify(source)] || []).includes(classify(candidate));
  const compatible = (first, second) => allowed(first, second) || allowed(second, first);
  const slot = product => ({swim_top:'tops',top:'tops',bodysuit:'tops',swim_bottom:'bottoms',bottom:'bottoms',swim_set:'onePieces',one_piece:'onePieces',full_outfit:'onePieces',outfit_set:'onePieces',swim_layer:'layers',layer:'layers'})[classify(product)];
  const rank = (source, candidate) => (rules[classify(source)] || []).indexOf(classify(candidate));
  window.BikiniYesOutfitPairing = {classify, allowed, compatible, available, slot, rank, sources: product => sources[classify(product)] || []};
})();
